import { render, staticRenderFns } from "./course.vue?vue&type=template&id=70d87d9a&scoped=true&"
import script from "./course.vue?vue&type=script&lang=js&"
export * from "./course.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d87d9a",
  null
  
)

export default component.exports